import TemplateView from "../../TemplateView";
import WorkflowStatus from "../../workflowStatus/WorkflowStatus";
import UserTime from "../../user_time";

export default class WorkflowStatusTimeRow extends TemplateView {
    constructor({statusName, statusType, statusColorId, time}) {
        super();
        this.params = {
            statusName,
            statusType,
            statusColorId,
            time
        }
    }

    templateHtml() {
        return "<div class='totalSpent'>" +
               "  <div class='workflowStatusDescription'></div>" +
               "  <div class='workflowStatusTime'></div>" +
               "</div>";
    }

    afterRender() {
        this.$workflowStatus = this.find(".workflowStatusDescription");
        this.$time = this.find(".workflowStatusTime");
        new WorkflowStatus({
            name: this.params.statusName,
            type: this.params.statusType,
            colorId: this.params.statusColorId
        }).init(this.$workflowStatus);

        this.$time.text(UserTime.formatTimeWithDigitSeparator(this.params.time));
    }
}


// WEBPACK FOOTER //
// ./web/js/panels/project/WorkflowStatusTimeRow.js